import { render, staticRenderFns } from "./PurposeAddModal.vue?vue&type=template&id=29b10327&"
import script from "./PurposeAddModal.vue?vue&type=script&lang=js&"
export * from "./PurposeAddModal.vue?vue&type=script&lang=js&"
import style0 from "./PurposeAddModal.vue?vue&type=style&index=0&id=29b10327&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports